<div class="card-basic">
  <div class="data-card-container">
    <lib-ikp-info-card-title
      id="title"
      [infoCardType]="infoCardType()"
      [title]="title()"
      [truncateTitle]="truncateTitle()"
      [subtitle]="subtitle()"
      [iconPath]="iconPath()"
      [actionText]="actionText()"
      [actionColor]="actionColor()"
      [actionIcon]="actionIcon()"
      [actionButtonCategory]="actionButtonCategory()"
      [actionButtonSize]="actionButtonSize()"
      [actionButtonDisabled]="actionButtonDisabled()"
      [(isCollapsed)]="isCollapsed"
      [isCheckbox]="isCheckbox()"
      [isChecked]="isChecked()"
      (actionClicked)="onActionClicked()"
      [index]="index()"
      [attr.data-test]="dataTestAttribute()"
    />
    @if (!isCollapsed() && showContent()) {
      <div class="data-card-content-container">
        <ng-content />
      </div>
    }
  </div>
</div>
